//import images from 'assets/images/images'
import images from 'assets/images/images'
import Breadcrumbs from 'components/Breadcrumbs'
import useTranslate from 'hooks/useTranslate'
import React from 'react'
import { useState } from 'react'
import {useSelector} from 'react-redux'

const ImageSlider = ({ getItem, loading }) => {
	const [imgSlide, setImgSlide] = useState(0)
	const {t} = useTranslate()
	const { siteSettings } = useSelector((state) => state.general)

  const isImage = (url) => {
    return /\.(jpg|jpeg|png|gif)$/i.test(url)
  } 

	return (
		<div className='imageSlider'>
			{
				loading 
				? <div className="skeleton skeleton-text"/>
				: <Breadcrumbs className={'breadcrumbs px-0'} breadcrumbList={[
					{text:t('homePage'), link:'/'},
					{text: getItem?.categories?.length > 0 ? getItem?.categories[0]?.value : '' , link:getItem?.categories?.length > 0 ? `/kategori/${getItem?.categories[0]?.url}`:'/'},
					{text: getItem?.name?.toUpperCase() , link:'/'},
				]} /> 
			}
			{
				loading && <div className="skeleton skeleton-home-slider"/>
			}
			<div className='imageSlider-large'>
			<div className='product-badges'>
				{getItem?.isFeaturedProduct && (
					<div className='orangeBadge'>
						<img src={images.orangeBadge} alt='' /> <div className='orangeBadge-text'>{t('popular')}</div>
					</div>
				)}
				{getItem?.isNewProduct && (
					<div className='orangeBadge'>
						<img src={images.orangeBadge} alt='' /> <div className='orangeBadge-text'>{t('new')}</div>
					</div>
				)}
				{getItem?.isProductAward && (
					<div className='orangeBadge'>
						<img src={images.orangeBadge} alt='' /> <div className='orangeBadge-text'>{t('award')}</div>
					</div>
				)}
				{getItem?.spicinessLevel && getItem?.spicinessLevel > 0 && (
					<div className='orangeBadge'>
						<img src={images.badgeYellowBg} alt='' /> <div className="orangeBadge-images">
							{
								[...Array(4)].map((v,i) => <img key={v} src={ i+ 1 <=  getItem?.spicinessLevel ?  images.badgeHot : images.badgeHotEmpty } />)
							}
						</div>
					</div>
				)}
				{getItem?.isVegetarian && (
					<div className='orangeBadge'>
						<img src={images.badgeYellowBg} alt='' />
						<div className="orangeBadge-images">
							<img src={ siteSettings?.common?.vegetarianIconPath} />
						</div>
					</div>
				)}
			</div>
        {isImage(getItem?.productImages[imgSlide]) ? (
								<img src={getItem?.productImages[imgSlide]} alt={getItem?.name} />
							) : (
								<video muted autoPlay width='100%' height='100%'>
									<source src={getItem?.productImages[imgSlide]} type='video/mp4' />
									{t('browserNotSupport')}
								</video>
							)}
			</div>
			<div className='imageSlider-small'>
				{/* <div className='active'>
          <img src={images.anayemek} alt="" />
        </div> */}
				{getItem?.productImages?.map((image, i) => {
					
					return (
						<div onClick={() => setImgSlide(i)} key={i}>
							{isImage(image) ? (
								<img src={image} alt='' />
							) : (
								<video muted autoPlay width='100%' height='100%'>
									<source src={image} type='video/mp4' />
									{t('browserNotSupport')}
								</video>
							)}
						</div>
					)
				})}
			</div>
			<div className='imageSlider-text'>
				<h2 className='imageSlider-text-xlarge'>{getItem?.shortDescription}</h2>
				<div className='imageSlider-text-large'>{getItem?.description}</div>
			</div>
		</div>
	)
}

export default ImageSlider
